// extracted by mini-css-extract-plugin
module.exports = {"textArea":"text-area_textArea__2h98A","wrapper":"text-area_wrapper__3fkQk","wrapperError":"text-area_wrapperError__3TSEi","iconWrapper":"text-area_iconWrapper__rtCs0"};